import { ChangeDetectionStrategy, Component, Inject, OnInit, ViewChild, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { MatTableModule, MatTableDataSource } from "@angular/material/table";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltip } from "@angular/material/tooltip";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatButtonModule } from "@angular/material/button";
import { MatPaginator, MatPaginatorModule } from "@angular/material/paginator";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { CoreService } from "../../../services/core.service";
import { SocialAistateListService } from "../../../services/social-ai-state-list.service";

@Component({
  selector: "app-delete-confirm-dialog",
  standalone: true,
  template: `
    <h2 mat-dialog-title class="text-red-50">Confirm Delete</h2>
    <mat-dialog-content>
      Are you sure you want to delete post with title: <b>{{ data.rss_title }}</b>?
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Cancel</button>
      <button mat-button color="warn" [mat-dialog-close]="'confirm'">Delete</button>
    </mat-dialog-actions>
  `,
  imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, MatButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeleteConfirmDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { rss_title: string }) { }
}

@Component({
  selector: "app-social-ai-list-of-posts-table",
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatIconModule,
    MatTooltip,
    MatFormFieldModule,
    MatButtonModule,
    FormsModule
  ],
  templateUrl: "./social-ai-list-of-posts-table.component.html",
  styleUrls: ["./social-ai-list-of-posts-table.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SocialAiListOfPostsTableComponent implements OnInit {
  displayedColumns: string[] = [
    "new_post",
    "id",
    "domain_name",
    // "rss_description",
    "rss_title",
    "platform_tag",
    "week_day",
    "scheduled_for",
    "post_status",
    'status_icon',
    "source",
    "actions",
    "enable_repeat",
  ];

  companyID: number = 0;
  dataSource = new MatTableDataSource<any>([]);
  totalItems = 0;
  pageSize = 12;
  searchValue: string = "";
  isLoading = false;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  weekDays: string[] = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

  private dialog = inject(MatDialog);

  constructor(
    private coreService: CoreService,
    private route: ActivatedRoute,
    private router: Router,
    private listState: SocialAistateListService
  ) { }

  ngOnInit(): void {

    //restore previous filters if any
    if (this.listState.searchValue) {
      this.searchValue = this.listState.searchValue;
      console.log(this.listState.searchValue)
    }

    const savedPage = this.listState.page || 1;

    this.route.queryParams.subscribe((params) => {
      const page = params["page"] ? Number(params["page"]) : savedPage;
      this.loadData(page);
    });
  }

  loadData(page: number) {
  this.companyID = this.coreService.user?.companyID || 0;
  this.listState.page = page; //save current page to state

  this.isLoading = true; 

  this.coreService
    .postData("posts/index", {
      company_id: this.companyID,
      page,
      q: this.searchValue
    })
    .subscribe({
      next: (res: any) => {
        this.dataSource.data = res.data || [];
        this.totalItems = res.total;
        this.pageSize = res.per_page;

        if (this.paginator) {
          this.paginator.pageIndex = res.current_page - 1;
          this.paginator.length = res.total;
          this.paginator.pageSize = res.per_page;
        }
      },
      error: (err) => {
        console.error('Load error:', err);
        this.dataSource.data = [];
      },
      complete: () => {
        this.isLoading = false; 
      }
    });
}

  domainSlug(domain?: string): string | null {
    if (!domain) return null;
    const host = String(domain).toLowerCase()
      .replace(/^https?:\/\//, '')
      .replace(/^www\./, '')
      .split(/[\/:?#]/)[0];
    return host.split('.')[0].replace(/[^a-z0-9]/g, '') || null;
  }
naPlaceholder = './assets/images/na.png';
  onMainImgError(ev: Event): void {
    const img = ev.target as HTMLImageElement;
    // prevent infinite loop if the placeholder also fails
    if (!img || img.src.endsWith(this.naPlaceholder)) return;
    img.src = this.naPlaceholder;
  }
   isScheduledForToday(dateString: string | Date): boolean {
    if (!dateString) return false;

    const date = new Date(dateString);
    const today = new Date();

    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  }

  formatPlatformTag(platform: string, tag: string): string {
    if (!platform || !tag) return platform || tag || "";


    const mappings: any = {
      "Facebook_photolink": "Facebook Link Post",
      "Facebook_fbphotopost": "Facebook Photo Post",
      "Facebook_fbfirstcomment": "Facebook Photo Post (first comment)",
      "Facebook_fbvideo": "Facebook Video Post",
      "Facebook_fbstoryvideo": "Facebook Story Video",
      "Facebook_fbstoryphoto": "Facebook Story Photo",
      "Facebook_fbreel": "Facebook Reel Post",
      "Facebook_fbstoryreel": "Facebook Story Reel",
      "Instagram_igphotopost": "Instagram Photo Post",
      "Instagram_igvideo": "Instagram Video Post",
      "Instagram_igcarousel": "Instagram Carousel Post",
      "Instagram_igstoryvideo": "Instagram Story Video",
      "Instagram_igstoryphoto": "Instagram Story Photo",
      "Instagram_igreel": "Instagram Reel Post",
      "Instagram_igstoryreel": "Instagram Story Reel",
      "TikTok_tiktokstoryvideo": "TikTok Story Video",
      "TikTok_tiktokstoryphoto": "TikTok Story Photo",
      "TikTok_tiktokcarousel": "TikTok Carousel Post",
      "TikTok_tiktokvideo": "TikTok Video Post",
      "TikTok_tiktokreel": "TikTok Reel Post",
      "TikTok_tiktokstoryreel": "TikTok Story Reel"
    };

    const key = `${platform}_${tag}`;
    return mappings[key] || `${platform} ${tag}`;
  }

  postStatusForm(value: string): string {
    if (!value) return "";
    return value.replace(/([A-Z])/g, " $1").trim();
  }

  onPageChange(event: any) {
    const newPage = event.pageIndex + 1;
    this.loadData(newPage);
  }

  onSearchSubmit(value: string) {
    this.searchValue = value.trim();
    this.listState.searchValue = this.searchValue; //save filter
    this.loadData(1);
  }

  clearSearch() {
    this.searchValue = "";
    this.listState.searchValue = ""; //clear state too
    this.loadData(1);
  }
  editRow(row: any) {
    this.router.navigate(["/edit-post", row.id]);
  }

  reuseRow(row: any) {
    this.router.navigate(["/reuse-post", row.enable_repeat === -1 ? row.parent_post_id : row.id]);
  }

  repeatPostRow(row: any) {
    this.router.navigate(["/repeat-post", row.id]);
  }

  viewRow(row: any) {
    this.router.navigate([
      "/preview-post",
      row.tag,
      row.enable_repeat === -1 ? row.parent_post_id : row.id,
    ]);
  }

  openDeleteConfirm(row: any) {
    const dialogRef = this.dialog.open(DeleteConfirmDialogComponent, {
      width: "380px",
      data: { rss_title: row.rss_title }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === "confirm") {
        this.deleteRow(row);
      }
    });
  }

  deleteRow(row: any) {
    this.coreService.postData(`manual-post/deletePost/${row.id}`, {
      company_id: this.companyID
    }).subscribe(() => {
      this.loadData(1);
    });
  }

   createNewPost() {
    this.router.navigateByUrl('/create-post');
  }
  createBulkPost() {
    this.router.navigateByUrl('/bulk-upload');
  }

}